{
  "dismiss": "Zrušiť"
}
